module.exports = __webpack_public_path__ + "static/img/02.ce32f9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/subscribe/02.jpg
// module id = R6fz
// module chunks = 1